import { call, put } from 'typed-redux-saga/macro';
import { createSliceSaga } from 'redux-toolkit-saga';

import { PayloadAction } from '@reduxjs/toolkit';

import { updateProcessState } from '../../../redux-slices/processes';

import { DOC_RAW_DATA_REPORTS_PROCESSING } from '../../../redux-slices/processes/constants';

import { Log } from '../../../../utils/logger';
import downloadFile from '../../../../utils/downloadFile';

import { ICallbackSaga } from '../../../../models/ICallbackSaga';
import { ReportsFilenamePrefixEnum } from '../common/models';
import { generateFilenameWithDate } from '../../../../utils/generateFilenameWithDate';
import { getDOCRawDataReports } from './api';

const docReportsSlice = createSliceSaga({
  caseSagas: {
    *downloadDOCRawDataReport({ payload }: PayloadAction<ICallbackSaga>) {
      try {
        yield put(updateProcessState(DOC_RAW_DATA_REPORTS_PROCESSING));
        const name = generateFilenameWithDate(
          ReportsFilenamePrefixEnum.RawDataReport,
        );
        const response = yield* call(getDOCRawDataReports);
        yield downloadFile(response.data, name);
        payload?.success?.(response.data);
      } catch (err: any) {
        Log.errorException(err);
        payload?.error?.(err && err.response && err.response.data);
      } finally {
        yield put(updateProcessState(DOC_RAW_DATA_REPORTS_PROCESSING));
      }
    },
  },
  name: 'reports-saga',
});

export default docReportsSlice.saga;
export const { downloadDOCRawDataReport } = docReportsSlice.actions;
export const { actions } = docReportsSlice;
